import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sidebar-badge',
    templateUrl: './sidebar-badge.component.html',
    styleUrls: ['./sidebar-badge.component.css'],
    standalone: false
})
export class SidebarBadgeComponent implements OnInit {

  @Input() count: number | undefined;
  constructor() { }

  ngOnInit() {
  }

}